import React, { useRef } from 'react';
import { FORM_NAME, STREAM, RECORDER, RECORDER_STATE, RECORDER_STATES } from './fields';
import { useSelector, useDispatch } from 'react-redux';
import { getFormValues } from 'redux-form';
import { ConfirmationDialog } from 'components/confirmation-dialog';
import { resumeRecording } from './recording-step';
import { closeWebcamRecordingDialog } from './index';
import { showDialogAction } from 'components/redux-dialog/actions';
import { pauseRecording } from './recording-step';

const DIALOG_NAME = 'CancelRecordingDialog';

export const openCancelRecordingDialog = () => showDialogAction(DIALOG_NAME);

export const CancelRecordingDialog = () => {
  const previousRecordingStateRef = useRef();
  const dispatch = useDispatch();
  const formData = useSelector(getFormValues(FORM_NAME));

  const handleClose = (ok) => {
    if (ok) {
      closeWebcamRecordingDialog(dispatch, formData?.[STREAM]);
    } else if (formData[RECORDER] && previousRecordingStateRef.current !== RECORDER_STATES.PAUSED) {
      resumeRecording(dispatch, formData[RECORDER]);
    }
  };

  const handleOpen = () => {
    previousRecordingStateRef.current = formData[RECORDER_STATE];
    if (formData[RECORDER]) {
      pauseRecording(dispatch, formData[RECORDER]);
    }
  };

  return (
    <ConfirmationDialog
      handleClose={handleClose}
      title="exit_recording_title"
      body="exit_recording_body"
      okLabel="exit"
      dialogName={DIALOG_NAME}
      onOpen={handleOpen}
    />
  );
};
